import { TagUnion } from '@/types/schema';

import { useTagQuery } from '../graphql/queries/generated/tag';

export default function useTag({
  name,
  tagId,
  pause,
}: {
  name?: string;
  tagId?: string;
  pause?: boolean;
}) {
  const [{ data, fetching, error }] = useTagQuery({
    variables: {
      filters: {
        tagId,
        name,
      },
    },
    pause: pause || (!tagId && !name),
  });

  return {
    tag: data?.tag as TagUnion | undefined,
    fetching,
    error,
  };
}
